import { useContext } from 'react';
import { AuthB2cContext } from '../context/AuthB2cContext';

const RequireToken = ({ children }: { children: JSX.Element }) => {
  const authB2cContext = useContext(AuthB2cContext);

  if (!authB2cContext?.user || !authB2cContext?.user?.access_token || !authB2cContext?.user?.visitId) {
    return (
      <div>
        <p className="text-xl font-semibold">Errore, token mancante</p>
        <p>Questo link non è valido, seguire le istruzioni accedendo dal link corretto.</p>
      </div>
    );
  }

  return children;
};

export default RequireToken;
